import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Projects from './pages/Projects'
import About from './pages/About'
import ProjectDetails from './pages/ProjectDetails';
import Modules from './pages/Modules'
import ModuleDetails from './pages/ModuleDetails';
import ScrollToTop from './components/ScrollToTop'
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react'



function App() {
  const location = useLocation();
  const TRACKING_ID = "G-50RRV7SZ75";
  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Thaw Tun Zan - Portfolio</title>
        <meta name="description" content="Computer Engineering Student Portfolio - Thaw Tun Zan" />
      </Helmet>
      
      <div className="min-h-screen bg-primary-900">
        <Navbar />
        <main>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="/modules" element={<Modules />} />
            <Route path="/modules/:id" element={<ModuleDetails />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  )
}

export default App 